// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jobapp-container {
  min-width: 300px;
}
.jobapp-container i {
  color: #000;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/PortalApplicationContent/PortalApplicationContent.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAEE;EACE,WAAA;AAAJ","sourcesContent":[".jobapp-container {\n  min-width: 300px;\n  // max-width: 1080px;\n\n  i {\n    color:#000;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
